export enum RepoEntryType {
  File = "file", Dir = "dir"
}

export interface RepoEntry {
  '@type': RepoEntryType;
  key: string;
  name: string;
  shortName: string;
  relativeKey: string;
  perm: string;
}

export interface Folder extends RepoEntry {
  innerEntries: RepoEntry[];
}

export interface File extends RepoEntry {
  size: number;
}
